import UserRoleManagementListing from "../../Components/UserRoleManagement/UserRoleManagementListing"
export const UserRoleListings = () => {
    return (
        <UserRoleManagementListing />
    )
}